module.exports = __webpack_public_path__ + "static/media/auto-approve-locked-request-1.941888f9.png";